import styled from "styled-components";
import { Link } from "react-router-dom";

export const Button = styled.button`
  width: ${(props) => (props.width ? props.width : "")};
  height: ${(props) => (props.height ? props.height : "45px")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "16px")};
  outline: none;
  border: none;
  cursor:pointer;
  margin-top:${(props) => (props.marginTop ? props.marginTop : "")};
  margin-left:${(props) => (props.marginL ? props.marginL : "")};
  margin:${(props) => (props.margin ? props.margin : "")};
  color: ${(props) => (props.color ? props.color : "white")};
  background-color:${(props) => (props.backgroundColor ? props.backgroundColor : " #437ced")};
  // background-image:  ${(props) => (props.backgroundImage ? props.backgroundImage : "#437ced")} ;
  border-radius: ${(props) => (props.borderRadius ? props.borderRadius : "5px")};
  padding:${(props) => (props.padding ? props.padding : "")};
  float:${(props) => (props.float ? props.float : "")};
  @media (max-width: 400px) {
    width:100% !important;
  }
  @media (min-width: 401px) and (max-width: 767px){
    width:100% !important;
  }
  &:hover{
    color:white !important;
    // background-image:linear-gradient(to right,#A45BE4 0%, #6B42F6 70%) !important;
    background-image:linear-gradient(315deg, rgb(68, 135, 209) 0%, rgb(0, 159, 253) 74%) !important;
    // box-shadow: 5px 5px 10px 1px grey;
  }

  // display: inline-block;
  // padding: .75rem 1.25rem;
  // border-radius: 10rem;
  // color: #fff;
  // text-transform: uppercase;
  // font-size: 1rem;
  // letter-spacing: .15rem;
  // transition: all .3s;
  // position: relative;
  // overflow: hidden;
  // z-index: 1;
  // &:after {
  //   content: '';
  //   position: absolute;
  //   bottom: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 100%;
  //   background-color: $color;
  //   border-radius: 10rem;
  //   z-index: -2;
  // }
  // &:before {
  //   content: '';
  //   position: absolute;
  //   bottom: 0;
  //   left: 0;
  //   width: 0%;
  //   height: 100%;
  //   background-color:#437ced;
  //   transition: all .3s;
  //   border-radius: 10rem;
  //   z-index: -1;
  // }
  // &:hover {
  //   color: #fff !important;
  //   &:before {
  //     width: 100%;
  //   }
  // }

`;

export const ButtonGrey = styled.button`
  width: ${(props) => (props.width ? props.width : "")};
  height: ${(props) => (props.height ? props.height : "45px")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "16px")};
  outline: none;
  border: none;
  cursor:pointer;
  margin-top:${(props) => (props.marginTop ? props.marginTop : "")};
  margin-left:${(props) => (props.marginL ? props.marginL : "")};
  margin:${(props) => (props.margin ? props.margin : "")};
  color: ${(props) => (props.color ? props.color : "white")};
  background-color:${(props) => (props.backgroundColor ? props.backgroundColor : " #437ced")};;
  border-radius: ${(props) => (props.borderRadius ? props.borderRadius : "5px")};
  padding:${(props) => (props.padding ? props.padding : "")};
  float:${(props) => (props.float ? props.float : "")};
  @media (max-width: 400px) {
    width:100% !important;
  }
`;

export const CustomLinkButLink = styled(Link)`
  margin-top: 10px !important;
  margin-left: 15px !important;
  width: auto;
  padding:8px 35px;
  border-radius: 20px;
  font-weight:600;
  font-size:16px;
  text-decoration: none;
  background-color: rgb(208, 210, 211);
  color:rgb(96, 96, 96);
  border:none;
  font-family: Montserrat, 'Open Sans', Helvetica, Arial, sans-serif;
  &:hover {
    background-image: linear-gradient(315deg, #4487d1 0%, #009ffd 74%) !important;
    color:white !important;
    transform: scale(1.1) !important;
    box-shadow:5px 5px 10px 1px #C8C8C8;
  }
`

